<template>
  <div id="app" :data-theme="currentTheme">
    <Toast />
    <ConfirmDialog />
    
    <div v-if="!isLoginPage" class="p-flex p-flex-column p-min-h-screen">
      <!-- Header with Navigation Menu (only for authenticated users) -->
      <AppHeader @theme-changed="onThemeChanged" />

      <!-- Main Content -->
      <main class="p-flex-1 p-p-6 p-bg-surface-ground p-min-h-calc-100vh-80 p-p-3:md">
        <router-view />
      </main>
      
      <!-- Footer -->
      <Footer @theme-changed="onThemeChanged" />
    </div>

    <!-- Login/Register pages -->
    <div v-else>
      <router-view />
    </div>
    

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AppHeader from './components/AppHeader.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    Footer
  },
  computed: {
    ...mapState(['currentUser', 'isAuthenticated', 'version', 'buildDate', 'currentTheme']),
    isLoginPage() {
      return this.$route.name === 'login' || this.$route.name === 'register'
    }
  },
  methods: {
    ...mapActions(['initializeSPA', 'fetchVersionInfo', 'changeTheme']),
    
    onThemeChanged(newTheme) {
      this.changeTheme(newTheme)
      this.applyTheme(newTheme)
    },
    
    applyTheme(theme) {
      // Apply theme to document
      document.documentElement.setAttribute('data-theme', theme)
      
      // Update body class
      document.body.className = document.body.className.replace(/theme-\w+/g, '')
      document.body.classList.add(`theme-${theme}`)
      
      // Force PrimeVue components to re-render
      this.$nextTick(() => {
        window.dispatchEvent(new Event('theme-changed'))
      })
    }
  },
  async mounted() {
    // Отримуємо інформацію про версію при завантаженні
    await this.fetchVersionInfo();
    
    // Check authentication status on app load
    if (this.isAuthenticated && !this.currentUser) {
      await this.$store.dispatch('fetchCurrentUser')
    }
    
    // Initialize SPA functionality
    if (this.isAuthenticated) {
      await this.initializeSPA()
    }
    
    // Set initial theme
    this.applyTheme(this.currentTheme)
  },
  watch: {
    isAuthenticated(newVal) {
      if (newVal) {
        this.initializeSPA()
      }
    }
  }
}
</script>

<style scoped>
/* PrimeVue utility classes now handle all styling */
/* No custom CSS needed - all styling is done through PrimeVue classes */

/* Custom calculation for min-height that can't be handled by PrimeVue utilities */
:deep(.p-min-h-calc-100vh-80) {
  min-height: calc(100vh - 80px);
}

/* Sticky footer layout */
.p-flex-column {
  min-height: 100vh;
}

.p-flex-1 {
  flex: 1;
}
</style> 